import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Beneficios } from './Beneficios';
import { Competencias } from './Competencias';
import { Configuracao } from './Configuracao';
import { Eventos } from './Eventos';
import { Holerites } from './Holerites';
import { i18n } from './i18n';

const modulo: ModuloWeb = {
  slug: 'folha',
  menu: 'pessoas',
  ordem: 20,
  abas: [
    { chave: 'beneficios', permissao: 'folha.ver', componente: Beneficios },
    { chave: 'eventos', permissao: 'folha.ver', componente: Eventos },
    { chave: 'competencias', permissao: 'folha.ver', componente: Competencias },
    { chave: 'holerites', permissao: 'folha.ver', componente: Holerites },
    { chave: 'configuracao', permissao: 'folha.ver', componente: Configuracao },
  ],
  i18n,
};

export default modulo;
